import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P23-E1',
    audio: 'img/FriendsPlus/Page23/Audio/audio-e1-p23.mp3',
    video: '',
    component: D1,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/tieude-e1-p23.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E1/4.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/ar.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/car.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/park.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/9.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/shark.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/11.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/star.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/13.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/scarf.mp3' },
      ],

    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P23-E2',
    audio: 'img/FriendsPlus/Page23/Audio/audio-e2-p23.mp3',
    video: '',
    component: UI,
    // exerciseKey: '',
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page23/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page23/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/tieude-e2-p23.mp3' },
        { url: 'img/FriendsPlus/Page23/E2/3.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page23/E2/4.jpg' },
      ],

    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P23-E3',
    audio: '',
    video: '',
    totalInput: 3,
    component: DesignUnderLine,
    exerciseKey: 'img/FriendsPlus/Page23/E3/Key/answerKey.png',
    // exerciseKey: '',
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page23/E3/0.jpg' },
      ]
      , [
        // Column1
        { url: 'img/FriendsPlus/Page23/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page23/E3/4.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page23/E3/5.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page23/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/7.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page23/E3/8.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page23/E3/9.jpg', input: 6 },
        { url: 'img/FriendsPlus/Page23/E3/10.jpg', input: 7 },
        { url: 'img/FriendsPlus/Page23/E3/11.jpg', input: 8, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/12.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page23/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/14.jpg', input: 9 },
        { url: 'img/FriendsPlus/Page23/E3/15.jpg', input: 10 },
        { url: 'img/FriendsPlus/Page23/E3/16.jpg', input: 11 },
        { url: 'img/FriendsPlus/Page23/E3/17.jpg', input: 12 },
        { url: 'img/FriendsPlus/Page23/E3/18.jpg', input: 13, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/19.jpg', input: 14 },
        { url: 'img/FriendsPlus/Page23/E3/20.jpg', input: 15 },
        { url: 'img/FriendsPlus/Page23/E3/21.jpg', input: 16 },
        { url: 'img/FriendsPlus/Page23/E3/22.jpg', input: 17 },
        { url: 'img/FriendsPlus/Page23/E3/23.jpg', input: 18, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/24.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page23/E3/25.jpg' },
      ],


    ],
  },
  4: { // Exercise num
    unit: 'Unit 3',
    id: 'SB1-U3-P23-E4',
    audio: '',
    video: '',
    component: D1,
    textAlign: 'center',
    exerciseKey: 'img/FriendsPlus/Page23/E4/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page23/E4/3.jpg', input: true, answer: "shark" },
        { url: 'img/FriendsPlus/Page23/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page23/E4/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page23/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page23/E4/7.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page23/E4/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page23/E4/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page23/E4/10.jpg' },
        { url: 'img/FriendsPlus/Page23/E4/11.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page23/E4/12.jpg' },
        { url: 'img/FriendsPlus/Page23/E4/13.jpg', input: true, answer: "farm" },
        { url: 'img/FriendsPlus/Page23/E4/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page23/E4/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page23/E4/16.jpg' },
        { url: 'img/FriendsPlus/Page23/E4/17.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page23/E4/18.jpg' },
        { url: 'img/FriendsPlus/Page23/E4/19.jpg', input: true, answer: "star" },
        { url: 'img/FriendsPlus/Page23/E4/20.jpg' },
      ],

    ]
  },
  5: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P23-E5',
    audio: '',
    video: '',
    recorder: true,
    component: UI,
    // exerciseKey: '',
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page23/E5/1.jpg' },
      ],

    ],
  },


}

export default json;